module.exports = __webpack_public_path__ + "img/Step5.5f4d1844.jpg";